module.exports = __webpack_public_path__ + "static/img/bg.428db33f.png";